export default __webpack_public_path__ + "static/media/TL15.55d6dbb1.mp3";